<template>
  <div class="wrapper">
    <div class="photo-container">
      <img v-if="filename" :src="filename" class="photo" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Transitions',
  computed: {
    filename() {
      return require(`../../../../public/demo/photo/transitions/${this.currentId}-${this.currentColor + 1}.gif`);
    },
    currentId() {
      return this.$parent.LeftSelectedValue.id;
    },
    currentColor() {
      return this.$parent.transitionColor;
    },
  },
};
</script>

<style scoped>
.wrapper {
  width: 100%;
}
.photo-container {
  margin: auto;
  position: relative;
}

.photo {
  width: 100%;
}
</style>
